import React from 'react';
import {Button as RNEButton, ButtonProps as RNEButtonProps} from '@rneui/themed';

// @rneui's ButtonProps extends PressableProps, so it permits function children,
// but the themed Button only accepts a ReactNode. Narrow to what it really takes.
type ButtonProps = Omit<RNEButtonProps, 'children'> & {children?: React.ReactNode};

const Button = (props: ButtonProps) => {
  return (
    <RNEButton
      radius="sm"
      size="sm"
      {...props}
      buttonStyle={[
        {
          width: 200,
          alignSelf: 'center',
        },
        props.buttonStyle,
      ]}
    />
  );
};

export default Button;
